module.exports = __webpack_public_path__ + "img/Technischer_Zug_mit_FGr_Wassergefahren.ea6826ee.svg";